import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.49967 18.5101C4.80509 18.5101 0.989258 14.6943 0.989258 9.99967C0.989258 5.30509 4.80509 1.48926 9.49967 1.48926C14.1943 1.48926 18.0101 5.30509 18.0101 9.99967C18.0101 14.6943 14.1943 18.5101 9.49967 18.5101ZM9.49967 2.67676C5.46217 2.67676 2.17676 5.96217 2.17676 9.99967C2.17676 14.0372 5.46217 17.3226 9.49967 17.3226C13.5372 17.3226 16.8226 14.0372 16.8226 9.99967C16.8226 5.96217 13.5372 2.67676 9.49967 2.67676Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.4369 13.1111C12.334 13.1111 12.2311 13.0874 12.1361 13.0241L9.68193 11.5595C9.07234 11.1953 8.62109 10.3957 8.62109 9.69115V6.44531C8.62109 6.12073 8.89026 5.85156 9.21484 5.85156C9.53943 5.85156 9.80859 6.12073 9.80859 6.44531V9.69115C9.80859 9.97615 10.0461 10.3957 10.2915 10.5382L12.7457 12.0028C13.0307 12.1691 13.1178 12.5332 12.9515 12.8182C12.8328 13.0082 12.6348 13.1111 12.4369 13.1111Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }